import { styled } from "styled-components";

export const ProductContainerDiv = styled.div`
  width: 80%;
  height: 120vh;
  margin: 0 auto;
  padding: 30px 0;
`;

export const ProductAttatchmentDiv = styled.div`
  width: 100%;
  height: 60vh;
  margin-top: 30px;
`;
//
export const ProductAttatchInputBox = styled.div`
  width: 100%;
  height: 30px;
`;

export const ProductInfoContainerDiv = styled.div`
  width: 100%;
  height: 20vh;
`;

export const ProductInfoFlexDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProductInfoDiv = styled.div`
  width: 50%;
  height: 100px;
`;

export const ProductDetailDiv = styled.div`
  height: 40%;
`;

export const ProductUploadBtn = styled.div`
  width: 120px;
  height: 50px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ead2d4;
`;

export const ProductDescDiv = styled.div`
  width: 100%;
`;

export const ProductTextarea = styled.textarea`
  width: 100%;
  height: 100px;
`;

export const H4 = styled.h4`
  display: inline-block;
`;
